export default function SectionHead({ eyebrow, title, lede, align = 'left', max = 720 }) {
  return (
    <div style={{
      textAlign: align,
      maxWidth: max,
      marginLeft: align === 'center' ? 'auto' : 0,
      marginRight: align === 'center' ? 'auto' : 0,
    }}>
      {eyebrow && (
        <div className="eyebrow reveal" style={{ marginBottom: 20 }}>
          <span className="dot" />
          {eyebrow}
        </div>
      )}
      <h2 className="h-1 reveal" style={{ marginBottom: lede ? 20 : 0 }}>{title}</h2>
      {lede && <p className="reveal" style={{ fontSize: 17, lineHeight: 1.55 }}>{lede}</p>}
    </div>
  );
}
